var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty"},[_c('img',{staticClass:"icon",style:('margin-top:'+_vm.mTop+'px'),attrs:{"src":require("@assets/img/common/empty.svg"),"alt":"empty"}}),_c('p',{staticClass:"msg"},[_vm._v("\n    "+_vm._s(_vm.msg)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }